export default {
  // Store access token in both the store and localStorage
  authSuccess(state) {
    state.isAuthenticated = true;
  },
  authLogout(state) {
    state.isAuthenticated = false;
  },
};
